/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  UpTimeArgumentInterface,
  UpTimeInitialProperties,
  UpTimeInterface,
} from '../../interface/uptime-interface';
import { removeEmptyKeys } from '../../shared-functions/DateTime';
import stationManagementApi from '../../utils/api/station-management';

export const fetchUpTimeListAndChartData = createAsyncThunk<
  UpTimeInterface[],
  UpTimeArgumentInterface
>(
  'UpTimeListAndChart/fetchUpTimeListAndChartData',
  async (data: UpTimeArgumentInterface, { dispatch }) => {
    try {
      const response = await stationManagementApi.fetchUptimeListAndChart(removeEmptyKeys(data));
      return response.data;
    } catch (error: any) {
      dispatch({
        type: 'notification/setNotificationDetails',
        payload: {
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || 'Something went wrong!',
          },
        },
      });
      throw error;
    }
  },
);

const initialState: UpTimeInitialProperties = {
  upTimeListAndChart: [],
  isLoading: false,
};

const UpTimeListAndChart = createSlice({
  name: 'uptime-list-and-chart',
  initialState,
  reducers: {},
  /**
   * Extra reducers
   * @param builder
   */
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpTimeListAndChartData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUpTimeListAndChartData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.upTimeListAndChart = action.payload;
      })
      .addCase(fetchUpTimeListAndChartData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default UpTimeListAndChart.reducer;
